export default __webpack_public_path__ + "static/conner-9a6ca703db35f1bb1d29f7ce85d6cb07.jpg";